module.exports = __webpack_public_path__ + "assets/coupon-orange-80b8c5.svg";